<savvas-shared-ui-line-chart
  tabindex="0"
  role="group"
  [lineChartItems]="growthScoreGraph?.lineChartItems"
  [xAxisConfigs]="growthScoreGraph?.xAxisConfigs"
  [yAxisConfigs]="growthScoreGraph?.yAxisConfigs"
  [tooltipConfigs]="growthScoreGraph?.toolTipConfigs"
  [chartMargin]="growthScoreGraph?.chartMargin"
  [chartStyleConfigs]="growthScoreGraph?.chartStyleConfigs"
></savvas-shared-ui-line-chart>
